import Footer from "@/components/common/layout/Footer/Footer";
import PageNotFound from "@/assets/images/common/404.webp";
import { GradientButton, Header } from "@/components";

export default function NotFound() {
	return (
		<div className="text-white">
            <Header />
			<div className="flex flex-col items-center justify-center min-h-[calc(100vh-120px)] px-6">
				<img src={PageNotFound} alt="404 - Page Not Found" className="img-responsive" />
				<h1 className="text-3xl sm:text-4xl md:text-6xl leading-tight font-semibold mt-12">OOPS!</h1>
				<h2 className="text-lg sm:text-xl md:text-3xl leading-tight font-semibold mt-2">Page not found</h2>
				<div className="mt-8 hero-text">
					<GradientButton>
						Back To Home
					</GradientButton>
				</div>
			</div>
			<Footer />
		</div>
	);
}
